/**
 * The name the scheduling settings give a capacity block the processor never
 * named. It exists only to tell several blocks on one day apart.
 * @param index - The block's position in its day, from zero
 * @returns "Block 1", "Block 2", …
 */
export const generatedBlockTitle = (index: number): string =>
  `Block ${index + 1}`;

/**
 * Whether a block title has the shape `generatedBlockTitle` produces.
 *
 * It reads the shape only: a processor who types "Block 2" themselves gets the
 * same answer. Use it to decide what to SHOW, not to rewrite a stored title.
 * @param title - A block title, as stored
 * @returns True for "Block 1", "block 12", " Block 3 " and the like
 */
export const isGeneratedBlockTitle = (title: string | null | undefined) =>
  /^block\s*\d+$/i.test(title?.trim() ?? '');
